import React, { useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CopyRight from "../../Assets/CopyRight";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import LoadingFull from "../../components/LoadingFull";
import Text from "../../components/Text";
import { getTabSetting } from "../../config/config";
import { router } from "../../Constants";
import { setOrder } from "../../redux/actions/prepareActions";
import api from "../../request";
import { decrypt, encrypt } from "../../utils/enkripsi";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import { onHitung } from "../../utils/onHitung";
import { socket } from "../../utils/socket";

function Bill({ }) {
  const state = useSelector((state) => state?.dataPrepare);
  const order = state?.order;
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const type = localStorage.getItem("type");
  const [loadingButton, setLoadingButton] = useState(false);
  const [dataBill, setDFataBill] = React.useState([]);
  const caraBayar = localStorage.getItem("typePayment") || "";

  async function createSocketData() {
    showLog("Bill Masuk createSocketData");
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    const detailDataMapping = {
      "1st_process_attempt": null,
      approved_by: "",
      approved_date: "",
      billed_by: null,
      billed_date: null,
      branch_address: "",
      branch_id: "",
      branch_name: "",
      branch_npwp: "-",
      branch_picpath: "",
      branch_tel1: "",
      cashlez_callbacked: null,
      cashlez_link: "",
      cashlez_qr: "",
      charges_note: [],
      charges_value: 0,
      charges_value_non_pb1: 0,
      charges_value_pb1: 0,
      charges_value_total: 0,
      checked_by: null,
      checked_date: null,
      checked_note: null,
      client_order_id: null,
      coa_ar_customer: "",
      coa_ar_customer_name: "",
      coa_dp_so: "",
      coa_dp_so_name: "",
      coa_dp_so_tax: "",
      coa_dp_so_tax_name: "",
      code: "",
      created_by: "",
      created_by_name: "",
      created_date: "",
      customer_address: "",
      customer_id: "",
      customer_name: "",
      customer_npwp: "",
      delivery_receiver_address: "",
      delivery_receiver_id: "",
      delivery_receiver_nama: null,
      delivery_receiver_name: null,
      delivery_receiver_phone: "",
      discounts_note: [],
      discounts_value: 0,
      discounts_value_total: 0,
      dp_so: 0,
      edit_lock_by: "",
      edit_lock_by_name: "",
      estimated_pickup_time: null,
      from: "",
      grand_total: 0,
      grand_total_nett: 0,
      harga_a_note: 0,
      harga_a_note_show: "",
      hide: 0,
      id: "",
      is_billed: 0,
      is_checked: 0,
      is_prepared: 0,
      is_prepared_show: "",
      jumlah_tamu: 0,
      kembali: 0,
      kurir_id: "-",
      kurir_layanan: null,
      kurir_service: null,
      marketing_id: "",
      marketing_name: "",
      no_faktur_pajak: "",
      note: "",
      oc_id: null,
      packaging: 0,
      payment_cash_coa: "",
      payment_cash_coa_name: "",
      payment_cash_value: 0,
      payment_cc1_coa: "",
      payment_cc1_coa_name: "",
      payment_cc1_edc: "",
      payment_cc1_note: "",
      payment_cc1_value: 0,
      payment_cc2_coa: "",
      payment_cc2_coa_name: "",
      payment_cc2_edc: "",
      payment_cc2_note: "",
      payment_cc2_value: 0,
      payment_dc1_coa: "",
      payment_dc1_coa_name: "",
      payment_dc1_edc: "",
      payment_dc1_note: "",
      payment_dc1_value: 0,
      payment_dc2_coa: "",
      payment_dc2_coa_name: "",
      payment_dc2_edc: "",
      payment_dc2_note: "",
      payment_dc2_value: 0,
      payment_others_coa: "",
      payment_others_coa_name: "",
      payment_others_edc: "",
      payment_others_note: null,
      payment_others_value: 0,
      payment_total: 0,
      payment_type: 0,
      payment_type_show: "",
      picpath: "",
      platform_order_id: null,
      po_customer: "",
      posted_acc_date: null,
      posted_acc_note: null,
      posted_acc_status: 0,
      posted_inv_date: null,
      posted_inv_note: null,
      posted_inv_status: 0,
      prepared_by: null,
      prepared_by_name: "",
      prepared_date: null,
      prepared_note: null,
      print_x_times: 0,
      print_x_times_A6: 0,
      processed_by: "",
      processed_by_name: "",
      processed_date: null,
      project_id: null,
      rc_id: "",
      reservation_detail_id: null,
      room_id: null,
      so_code: "",
      so_date: "",
      so_id: "",
      sr_id: "",
      sub_total: 0,
      sync_by: null,
      sync_date: null,
      sync_trans_status: 0,
      table_id: "",
      table_reservation_id: null,
      tgl_customer_terima: null,
      tgl_keluar: null,
      therapist_id: null,
      top: 0,
      total: 0,
      total_coin_earned: 0,
      total_point_earned: 0,
      trans_date: "",
      trans_from: "",
      trans_status: 0,
      trans_status_oc: null,
      trans_status_show: "",
      updated_by: "",
      updated_by_name: "",
      updated_date: "",
      void_by: "",
      void_by_name: "",
      void_date: null,
      void_note: null,
    };
    const orderSelectedMapping = {
      accepted_rejected_at: null,
      accepted_rejected_at_show: null,
      brand_id: "",
      coa_inv: "",
      coa_sales: "",
      curr: "",
      detail_disc1: 0,
      detail_disc2: 0,
      detail_disc_value: 0,
      detail_note: "",
      expired: "",
      header: null,
      height_packing: 0,
      // id: dataBranch.detailData,
      id: "",
      indent: 0,
      kitchen_type_id: "",
      length_packing: 0,
      ln: "-",
      name: "",
      num: 0,
      num_paket: null,
      ordered_at: "",
      ordered_at_show: "",
      ordered_by: "",
      picpath1_thumb: "",
      prepared_at: "",
      prepared_at_show: "",
      prepared_by: "",
      price: 0,
      product_id: "",
      product_name: "",
      promo_name: "",
      promo_paket: 0,
      promo_price: 0,
      promo_qty: 0,
      qty: 0,
      qty_order: 0,
      qty_unit: 0,
      rate: 0,
      sn: "",
      status_save: "",
      trans_id: dataBranch.detailData,
      table_id: localStorage.getItem("meja"),
      tipe_promo: null,
      total: 0,
      unit_id: "",
      unit_id_small: "",
      use_expired: 0,
      use_ln: 0,
      use_sn: 0,
      void_at: null,
      void_at_show: null,
      void_by: null,
      void_note: null,
      void_type: 0,
      warehouse_id: "",
      warehouse_name: "",
      weight_packing: 0,
      width_packing: 0,
    };
    const dataDetailData = decrypt(
      JSON.parse(localStorage.getItem("detailData"))
    );
    const datadetailTrans = decrypt(
      JSON.parse(localStorage.getItem("detailTrans"))
    );
    const mappedDetailData = mapData(dataDetailData, detailDataMapping);
    const orderSelectedArray = order.data[0].data.map((item) => ({
      ...orderSelectedMapping,
      ...item,
      product_name: item.name || "",
    }));
    mappedDetailData.charges_note = order.data[0].chagerNote;
    mappedDetailData.charges_note = mappedDetailData.charges_note.map(
      (item) => {
        return {
          id: item.label,
          value: item.value,
        };
      }
    );
    mappedDetailData.charges_value = mappedDetailData.charges_note
      .filter((item) => item.id !== "Subtotal" && item.id !== "Total")
      .reduce((sum, item) => sum + item.value, 0);
    const charges = mappedDetailData.charges_note;
    function getChargeValue(id) {
      const charge = charges.find((item) => item.id === id);
      return charge ? charge.value : 0;
    }
    mappedDetailData.sub_total = getChargeValue("Subtotal");
    mappedDetailData.total = getChargeValue("Total");
    mappedDetailData.grand_total = mappedDetailData.total;
    mappedDetailData.grand_total_nett = mappedDetailData.total;
    mappedDetailData.branch_address = dataBranch.branchAddress;
    mappedDetailData.branch_name = dataBranch.branchName;
    mappedDetailData.branch_tel1 = dataBranch.branchTel;
    mappedDetailData.picpath = dataBranch.picpath;
    mappedDetailData.picpath1_thumb = dataBranch.picpath_thumb;
    mappedDetailData.branch_npwp = dataBranch.npwpp;
    mappedDetailData.trans_date = order.data[0].date;
    mappedDetailData.delivery_receiver_name =
      localStorage.getItem("dataDiriName") || "";
    mappedDetailData.note =
      decrypt(JSON.parse(localStorage.getItem("customerNote"))) || "";
    const tableQrSocketData = {
      source: "FROM WEBSITE",
      table_id: localStorage.getItem("meja"),
      branch_id: dataBranch.branchID,
      trans_id: dataBranch.detailData,
      userServer: userServer,
      trans_date: order.data[0].date,
      detailData: mappedDetailData,
      orderSelected: orderSelectedArray,
      mode: ["kitchen", "transaction"],
      posData: {
        detailData: mappedDetailData,
        link: "",
        linkGet: "",
        orderSelected: orderSelectedArray,
        posForm: "",
        posMode: "",
        transMode: "",
      },
      jumlah_tamu: "",
      is_billed: "",
      billed_date: "",
      status: "",
      posMode: "",
      stat: 0,
    };
    sessionStorage.setItem(
      "tableQrSocketData",
      JSON.stringify(encrypt(tableQrSocketData))
    );
    let savedSiSocketData = {
      source: "FROM WEBSITE",
      billed_date: "",
      is_billed: "",
      jumlah_tamu: "",
      posMode: "",
      branch_id: dataBranch.branchID,
      table_id: localStorage.getItem("meja"),
      trans_date: order.data[0].date,
      trans_id: dataBranch.detailData,
      userServer: userServer,
    };
    sessionStorage.setItem(
      "savedSiSocketData",
      JSON.stringify(encrypt(savedSiSocketData))
    );
  }

  function mapData(source, target) {
    showLog("Bill Masuk mapData");
    const result = { ...target };
    for (const key in result) {
      if (source.hasOwnProperty(key)) {
        result[key] = source[key];
      } else {
        if (typeof result[key] === "string") result[key] = "";
        else if (Array.isArray(result[key])) result[key] = [];
        else if (result[key] === null) {
        } // no change needed
        else if (typeof result[key] === "number") result[key] = 0;
      }
    }
    return result;
  }

  async function onLacak(items) {
    showLog("Bill Masuk onLacak");
    let saveCustomer = decrypt(
      JSON.parse(localStorage.getItem("saveCustomer"))
    );
    const tabSetting = await getTabSetting("pesan_table_qr_nonmember");
    if (tabSetting.status === "OK") {
      if (
        tabSetting.data[0].onoff === 0 &&
        (!saveCustomer || saveCustomer == "false")
      ) {
        navigate(router + "/data-diri", {
          data: items["data"],
          id: items["id"],
        });
      } else {
        navigate(`${router}/metode-pembayaran/${items["id"]}`, {
          state: {
            data: items["data"],
            id: items["id"],
          },
        });
      }
    }
  }

  function prepareSocket() {
    showLog("Bill Masuk prepareSocket");

    const handleConnect = () => {
      showLog("Socket Connected");
    };

    const handleSavedSi = async (arg) => {
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        arg?.trans_id ?? arg?.transId ?? arg?.transID ?? arg?.id;

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      onRefresh("socket");
    };

    const handlePaymentSuccess = async (payload) => {
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        payload?.trans_id ??
        payload?.transId ??
        payload?.transID ??
        payload?.id ??
        payload?.data?.trans_id;

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      onRefresh("payment-success");
    };

    socket.on("connect", handleConnect);
    socket.on("saved-si", handleSavedSi);
    socket.on("payment-success", handlePaymentSuccess);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("saved-si", handleSavedSi);
      socket.off("payment-success", handlePaymentSuccess);
    };
  }

  async function onRefresh(value) {
    showLog("Bill Masuk onRefresh");
    const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
    const result = await api.apiPrepare.getOrder({
      id: orderDate.detailData,
    });
    const x = onHitung(result.data);
    let sub_total = [];
    sub_total.push({
      label: "Subtotal",
      value: x?.data?.sub_total,
    });
    for (const s of x.chargeNotes) {
      sub_total.push({
        label: s.id + " " + s.percent_value + "%",
        value: s.value,
      });
    }
    sub_total.push({
      label: "Total",
      value: x?.data?.grand_total_net,
    });
    if (localStorage.getItem("typePayment") == "Cash") {
      if (result.data[0].trans_status !== 0 && value) {
        navigate(`${router}/payment-succes`);
      }
    }
    for (const index in result.data) {
      const items = result.data[index];
      if (type == "tableQR") {
        // if (items.product_id == "QR") {
        let subtotal = 0,
          total = 0,
          tax = 0;
        for (const xi of result.data) {
          if (xi.product_id !== "QR") {
            subtotal += xi.price * xi.qty;
            total += xi.price * xi.qty;
          }
        }
        setDFataBill([
          {
            id: items.si_id,
            table_id: items.table_id,
            tanggal: items.trans_date,
            data: result.data.filter((items) => items.product_id !== "QR"),
            total: sub_total,
            trans_status: items.trans_status,
          },
        ]);
        // }
      }
      if (type == "takeaway") {
        if (index == "0") {
          let subtotal = 0,
            total = 0,
            tax = 0;
          for (const xi of result.data) {
            subtotal += xi.price * xi.qty;
            total += xi.price * xi.qty;
          }
          setDFataBill([
            {
              id: items.si_id,
              table_id: items.table_id,
              tanggal: items.trans_date,
              data: result.data.filter((items) => items.product_id !== "QR"),
              total: sub_total,
              trans_status: items.trans_status,
            },
          ]);
        }
      }
    }
  }

  React.useEffect(() => {
    showLog("Bill Masuk useEffect 1");
    const run = async () => {
      await onRefresh();
      await createSocketData();
    };
    run();
    const cleanup = prepareSocket();
    return cleanup;
  }, []);

  let trans_status = "";
  if (dataBill.length !== 0 && dataBill[0]["trans_status"] == 0) {
    trans_status = "Pending";
  }
  if (dataBill.length !== 0 && dataBill[0]["trans_status"] == 1) {
    trans_status = "Sukses";
  }
  const showPayButton = trans_status === "Pending";
  let fromPaymentSuccess = decrypt(
    JSON.parse(localStorage.getItem("fromPaymentSuccess"))
  );
  if (fromPaymentSuccess == "true") {
    const keysToKeep = [
      "type",
      "typePayment",
      "saveCustomer",
      "dataBranch",
      "fromPaymentSuccess",
      "userServer",
      "saveLinkOrder",
      "localCharges",
    ];
    const savedData = {};
    keysToKeep.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        savedData[key] = value;
      }
    });
    sessionStorage.clear();
    localStorage.clear();
    Object.keys(savedData).forEach((key) => {
      localStorage.setItem(key, savedData[key]);
    });
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {dataBill[0]?.trans_status == 0 && (
        <div style={{ width: "100%" }}>
          <div
            onClick={() => {
              dispatch(setOrder());
              navigate(`${router}/lacak-pesanan`);
            }}
            style={{ padding: "20px 10px", width: "10%" }}
          >
            <BiArrowBack size={20} />
          </div>
        </div>
      )}
      <Gap height={50} />
      <div
        style={{ justifyContent: "center", display: "flex", padding: "10px 0" }}
      >
        <Text className="fonts700" style={{ color: "#552CB7", fontSize: 17 }}>
          Your Bill
        </Text>
      </div>
      {dataBill &&
        dataBill.map((items, index) => {
          return (
            <div key={index} style={{ width: "100%" }}>
              <div style={{ margin: "0 30px" }}>
                <Text style={{ fontSize: 15 }} className="fonts500">
                  {items.id}
                </Text>
              </div>
              <Gap height={20} />
              <div
                style={{
                  border: `0.1px solid #BFBFBF`,
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  margin: "0 20px",
                }}
              >
                <div style={{ margin: "20px 20px" }}>
                  {/* {type == "tableQR" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontSize: 15 }} className="fonts500">
                        Nomer Meja
                      </span>
                      <span style={{ fontSize: 15 }} className="fonts500">
                        {items.table_id}
                      </span>
                    </div>
                  )} */}
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text style={{ fontSize: 15 }} className="fonts500">
                      Tanggal
                    </Text>
                    <Text style={{ fontSize: 15 }} className="fonts500">
                      {items.tanggal}
                    </Text>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Text style={{ fontSize: 15 }} className="fonts500">
                      Status
                    </Text>
                    <Text
                      style={{
                        fontSize: 15,
                        color:
                          trans_status == "Pending" ? "#F8991F" : "#26D044",
                      }}
                      className="fonts700"
                    >
                      {trans_status}
                    </Text>
                  </div>
                </div>
              </div>
              <Gap height={20} />
              <div
                style={{
                  border: `0.1px solid #BFBFBF`,
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  margin: "0 20px",
                }}
              >
                <div style={{ margin: "20px 20px" }}>
                  {items.data.map((item, index) => {
                    let is_prepared = "";
                    // if (item.is_prepared == 0) {
                    //     is_prepared = "Sedang disiapkan"
                    // }
                    if (item.is_prepared == 1) {
                      is_prepared = "Sudah disiapkan";
                    }
                    return (
                      <div key={index}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div
                              style={{
                                display: "flex",
                                justifyItems: "center",
                              }}
                            >
                              <span className="fonts700">{item.qty}x</span>
                              <Gap width={10} />
                              <span className="fonts500">
                                {(item.name || "")
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1).toLowerCase()
                                  )
                                  .join(" ")}{" "}
                              </span>
                            </div>
                            {item.detail_note && (
                              <div
                                className="fonts500"
                                style={{ fontSize: 14, color: "#BFBFBF" }}
                              >
                                {item.detail_note}
                              </div>
                            )}
                            {is_prepared !== "" && <Gap height={10} />}
                            {is_prepared !== "" && (
                              <span
                                className="fonts500"
                                style={{
                                  fontSize: 14,
                                  color:
                                    item.is_prepared == 0
                                      ? "#F8991F"
                                      : "#26D044",
                                }}
                              >
                                {is_prepared}
                              </span>
                            )}
                          </div>
                          <div>
                            <div className="fonts700">
                              Rp{formatterMoney(item.price * item.qty)}
                            </div>
                          </div>
                        </div>
                        <Gap height={10} />
                      </div>
                    );
                  })}
                </div>
              </div>
              <Gap height={20} />
              <div
                style={{
                  border: `0.1px solid #BFBFBF`,
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  margin: "0 20px",
                }}
              >
                <div style={{ margin: "20px 20px" }}>
                  {items.total.map((items, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 10,
                      }}
                    >
                      <div>
                        <div className="fonts700">{items.label}</div>
                      </div>
                      <div>
                        <div className="fonts700">
                          Rp{formatterMoney(items.value)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {showPayButton && (
                <div>
                  <Gap height={20} />
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 0",
                      margin: "0 auto",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setLoadingButton(false);
                        onLacak(items);
                      }}
                      loading={loadingButton}
                      backgroundColor="#5451D6"
                      color="#fff"
                    >
                      Bayar Sekarang
                    </Button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      {dataBill.length == 0 && <LoadingFull />}
      <Gap height={40} />
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <CopyRight />
      </div>
      <Gap height={20} />
    </div>
  );
}

export default Bill;
